import {envIsServerDeployment} from '../../config';

export function useIsOrgDashboardEnabled() {
  // todo(sammy): why envIsServerDeployment vs !envIsPublicCloud? it's unclear when to use one or the other,
  // but this is probably sufficient.
  return {isOrgDashboardEnabled: envIsServerDeployment};
}
